<div class="frac-fcpo-manage-loaders">
  <div class="dragable">
    <div class="example-container">
      <h2>Out of Network ({{ outOfNetworkLoaders.length }})</h2>

      <div class="search-bar">
        <input
          type="text"
          matInput
          placeholder="Search Out Of Network Loaders"
          [formControl]="outOfNetworkSearch"
          autocomplete="off"
        />
      </div>

      <div
        cdkDropList
        id="outOfNetwork"
        #outOfNetwork="cdkDropList"
        [cdkDropListData]="outOfNetworkLoaders"
        [cdkDropListConnectedTo]="[selectedClusterList]"
        class="example-list"
        (cdkDropListDropped)="drop($event)"
      >
        <div class="example-box" *ngFor="let mine of outOfNetworkLoaders" cdkDrag>
          {{ mine.site.name }}
          <span class="in-use" *ngIf="mine.inUse"> (In Use)</span>
        </div>
      </div>
    </div>

    <div class="example-container">
      <h2>In Network ({{ inNetworkLoaders.length }})</h2>

      <div class="search-bar">
        <input
          type="text"
          matInput
          placeholder="Search In Network Loaders"
          [formControl]="inNetworkSearch"
          autocomplete="off"
        />
      </div>

      <div
        cdkDropList
        #selectedClusterList="cdkDropList"
        id="inNetwork"
        [cdkDropListData]="inNetworkLoaders"
        [cdkDropListConnectedTo]="[outOfNetwork]"
        class="example-list"
        (cdkDropListDropped)="drop($event)"
      >
        <div class="example-box" *ngFor="let mine of inNetworkLoaders" cdkDrag>
          {{ mine.site.name }}
          <span class="in-use" *ngIf="mine.inUse"> (In Use)</span>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #loading>
  <div class="loading">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>
